import { DATE_TIME_FORMAT } from "@lhd/constants";
import { DatePicker, Form, Input, Space } from "antd";
import dayjs from "dayjs";
import moment from "moment";
import { useEffect, useState } from "react";
import { ItemInsuranceData } from "types/configTax.type";
import { Styles } from "./styled";

interface IProps {
  isRowAsHeader: boolean;
  isEdit: boolean;
  record: any;
  isCollapse?: boolean;
}

const StartDate = (props: IProps) => {
  const { isRowAsHeader, isEdit, record, isCollapse } = props;
  const form = Form.useFormInstance();
  const [open, setOpen] = useState(false);
  const [valueInput, setValueInput] = useState("");
  useEffect(() => {
    if (!isRowAsHeader) {
      const valueInput =
        record.start_date && dayjs(record.start_date).isValid()
          ? dayjs(record.start_date).format(DATE_TIME_FORMAT.DATE_JP)
          : "";
      setValueInput(valueInput);
    }
  }, []);

  if (isRowAsHeader) {
    const children = record.children || ([] as ItemInsuranceData[]);
    const start_date =
      (children[0] && children[0].start_date) ||
      (children[1] && children[1].start_date) ||
      "";

    if (start_date && isCollapse) {
      return <span>{dayjs(start_date).format(DATE_TIME_FORMAT.DATE_JP)}</span>;
    }
    return <span>有効期間</span>;
  }

  const isFirstRow = !!record.nextStartDate;
  if (!isEdit) {
    const endDate = record.end_date
      ? dayjs(record.end_date)
      : record.nextStartDate
      ? dayjs(record.nextStartDate).subtract(1, "day")
      : null;

    return (
      <div
        style={{
          textAlign: "center",
        }}
      >
        {endDate ? (
          `${dayjs(record.start_date).format(
            DATE_TIME_FORMAT.DATE_JP,
          )} ~ ${endDate.format(DATE_TIME_FORMAT.DATE_JP)}`
        ) : (
          <>
            <span>
              {dayjs(record.start_date).format(DATE_TIME_FORMAT.DATE_JP)}
            </span>

            <span
              style={{
                userSelect: "none",
                opacity: 0,
              }}
            >
              ~ {dayjs(record.start_date).format(DATE_TIME_FORMAT.DATE_JP)}
            </span>
          </>
        )}
      </div>
    );
  }

  const disabledDate = (current: moment.Moment | null) => {
    if (!current) return false;
    try {
      const today = dayjs().startOf("day");
      const currentDayjs = dayjs(current.toISOString());
      const prevStartDate = record.prevStartDate;
      const nextStartDate = record.nextStartDate;
      if (nextStartDate) {
        return (
          currentDayjs.isBefore(dayjs(prevStartDate).add(1, "day"), "day") ||
          currentDayjs.isBefore(today.add(1, "day"), "day") ||
          currentDayjs.isAfter(dayjs(nextStartDate).subtract(1, "day"), "day")
        );
      }
      return (
        currentDayjs.isBefore(dayjs(prevStartDate).add(1, "day"), "day") ||
        currentDayjs.isBefore(today.add(1, "day"), "day")
      );
    } catch (e) {
      return true;
    }
  };
  const names = [
    record.industry_category_id.toString(),
    record.id.toString(),
    "start_date",
  ];

  const formatDate = (value: string): string | null => {
    const valueTime = value
      .replaceAll("年", "-")
      .replaceAll("月", "-")
      .replaceAll("日", "")
      .replaceAll("/", "-")
      .replaceAll(" ", "-")
      .trim();
    const normalizedInput = valueTime.replace(/-+$/, "");
    const parts = normalizedInput.split("-").filter(Boolean);
    const [year, month, day] = parts;

    if (parts.length === 1) return dayjs(`${year}-01-01`).format("YYYY-MM-DD");
    const formattedMonth = month === "0" ? "01" : month?.padStart(2, "0");
    const formattedDay = day === "0" || !day ? "01" : day.padStart(2, "0");
    const formattedDate = dayjs(`${year}-${formattedMonth}-${formattedDay}`);

    const date = dayjs(`${year}-${formattedMonth}`, "YYYY-MM-DD", true);
    if (Number(day) > date.daysInMonth()) return null;
    return formattedDate.isValid() ? formattedDate.format("YYYY-MM-DD") : null;
  };

  return (
    <Styles>
      <Space
        direction="horizontal"
        style={{
          marginBottom: -23,
        }}
      >
        <Form.Item
          name={names}
          rules={[
            {
              message: "必須",
              required: true,
            },
          ]}
        >
          <DatePicker
            disabledDate={disabledDate}
            format={DATE_TIME_FORMAT.DATE_JP}
            open={open}
            onFocus={() => {
              setOpen(true);
            }}
            inputRender={() => (
              <Input
                style={{
                  border: "none",
                  background: "transparent",
                  outline: "none",
                  boxShadow: "unset",
                  width: "115px",
                }}
                placeholder="有効期間"
                value={valueInput}
                onFocus={() => {
                  setOpen(true);
                }}
                onBlur={() => {
                  setOpen(false);
                  const value = form.getFieldValue(names);
                  if (value) {
                    const valueInput = dayjs(value).format(
                      DATE_TIME_FORMAT.DATE_JP,
                    );
                    setValueInput(valueInput);
                  } else {
                    setValueInput("");
                  }
                }}
                onChange={(e) => {
                  try {
                    const value = e.target.value;
                    const valueDate = formatDate(value);
                    const valDay = dayjs(valueDate);
                    setValueInput(value);

                    if (valDay.isValid()) {
                      const isdisabledDate = disabledDate(
                        moment(valDay.format(DATE_TIME_FORMAT.DATE_QUERY)),
                      );
                      if (!isdisabledDate) {
                        form.setFieldValue(names, valDay);
                      }
                    }

                    form.validateFields([names]);
                  } catch (e) {
                    console.log(e);
                  }
                }}
              />
            )}
            onBlur={() => {
              setOpen(false);
              const value = form.getFieldValue(names);
              if (value) {
                const valueInput = dayjs(value).format(
                  DATE_TIME_FORMAT.DATE_JP,
                );
                setValueInput(valueInput);
              } else {
                setValueInput("");
              }
            }}
            onChange={(e) => {
              const value = e?.format(DATE_TIME_FORMAT.DATE_JP) || "";
              setValueInput(value);
            }}
          />
        </Form.Item>
        {isFirstRow && (
          <>
            <div
              style={{
                transform: "translate(0, -12px)",
              }}
            >
              ~
            </div>
            <Form.Item
              name={[
                record.industry_category_id.toString(),
                record.id.toString(),
                "end_date",
              ]}
              rules={[
                {
                  message: "必須",
                  required: true,
                },
              ]}
            >
              <DatePicker disabled format={DATE_TIME_FORMAT.DATE_JP} />
            </Form.Item>
          </>
        )}
      </Space>
    </Styles>
  );
};

export default StartDate;
